<div
  class="drawer-toasters"
  id="drawer-toast-container"
  aria-live="polite"
  aria-atomic="true"
  toastContainer
  data-testid="drawer.toast-container"
></div>
